const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#63c3d1;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M25.5,22.483H21.031a.459.459,0,0,1,0-.918H25.5a5.58,5.58,0,0,0,.909-11.087.458.458,0,0,1-.377-.371A7.346,7.346,0,0,0,12.111,8.385a.459.459,0,0,1-.542.252,4.779,4.779,0,0,0-6,3.678.46.46,0,0,1-.427.369,4.443,4.443,0,0,0,.227,8.881h5.6a.459.459,0,1,1,0,.918h-5.6A5.361,5.361,0,0,1,4.742,11.8,5.729,5.729,0,0,1,10.27,7.535a5.648,5.648,0,0,1,1.172.125A8.264,8.264,0,0,1,26.871,9.631,6.5,6.5,0,0,1,25.5,22.483Z",
  transform: "translate(0 -3.154)"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.512 7.498)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M18.792,29.624a.459.459,0,0,1-.459-.459V16.977a.459.459,0,0,1,.459-.459h1.243L16,11.809l-4.033,4.709h1.242a.459.459,0,0,1,.459.459V29.165a.459.459,0,0,1-.918,0V17.436H10.971a.459.459,0,0,1-.349-.758l5.031-5.873a.473.473,0,0,1,.7,0l5.031,5.873a.459.459,0,0,1-.349.758h-1.78V29.165A.459.459,0,0,1,18.792,29.624Z",
  transform: "translate(-10.512 -10.652)"
}));
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26.47,
    viewBox: "0 0 32 26.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c6c464688e67050ca94e52ad55497d19.svg";
export { ForwardRef as ReactComponent };